import classNames from 'classnames'
import React, {memo} from 'react'

import Actions from '../../../../../Actions/Actions'
import PipelineParameterForm from '../PipelineParameterForm/PipelineParameterForm'

import type {PipelineParameterProps} from './PipelineParameter.types'
import usePipelineParameter from './usePipelineParameter'

import styles from './PipelineParameter.css'

function PipelineParameter({value, name, deleted}: PipelineParameterProps) {
  const {
    id,
    isEditMode,
    isDisabled,
    currentParameterName,
    buttonConfirmClickHandler,
    buttonEditClickHandler,
    deleteButtonClickHandler,
    buttonRestoreClickHandler,
  } = usePipelineParameter(name)

  if (isEditMode && !isDisabled) {
    return (
      <div id={`${id}_${name}`} className={styles.parameter} data-test="job-parameter">
        <PipelineParameterForm
          onCancel={buttonEditClickHandler}
          onDelete={deleteButtonClickHandler}
          onConfirm={buttonConfirmClickHandler}
          name={currentParameterName}
          value={value}
        />
      </div>
    )
  }

  return (
    <div id={`${id}_${name}`} className={styles.parameter} data-test="job-parameter">
      <div className={classNames(styles.inputs, {[styles.deleted]: deleted})}>
        <div>{currentParameterName}</div>
        {'\u00a0=\u00a0'}
        <div>{value}</div>
      </div>
      <Actions
        className={styles.parameterActions}
        deleted={deleted}
        disabled={isDisabled}
        onRestoreClick={buttonRestoreClickHandler}
        onEditClick={buttonEditClickHandler}
        onDeleteClick={deleteButtonClickHandler}
      />
    </div>
  )
}

export default memo(PipelineParameter)
